import {storyBase} from "@/lib/api/sanity/queries/storyBase";

const storyBySlug = `
* [_type == 'story' && slug.current == $slug && !(_id in path("drafts.**"))]
${storyBase}
[$site in categories[].site]
[0]
`
export default storyBySlug
